module.exports = __webpack_public_path__ + "img/wrenchWheel.43912e2b.svg";